var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.5C17.279 7.5 17.067 7.5878 16.9107 7.74408C16.7545 7.90036 16.6667 8.11232 16.6667 8.33333V10.8333H3.33333V8.33333C3.33333 8.11232 3.24553 7.90036 3.08925 7.74408C2.93297 7.5878 2.72101 7.5 2.5 7.5C2.27898 7.5 2.06702 7.5878 1.91074 7.74408C1.75446 7.90036 1.66666 8.11232 1.66666 8.33333V11.6667C1.66666 11.8877 1.75446 12.0996 1.91074 12.2559C2.06702 12.4122 2.27898 12.5 2.5 12.5H17.5C17.721 12.5 17.933 12.4122 18.0893 12.2559C18.2455 12.0996 18.3333 11.8877 18.3333 11.6667V8.33333C18.3333 8.11232 18.2455 7.90036 18.0893 7.74408C17.933 7.5878 17.721 7.5 17.5 7.5Z",
    fill: "#325CCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceKey);
export default __webpack_public_path__ + "static/media/space-key.617c0a35.svg";
export { ForwardRef as ReactComponent };